import { Panel } from '../components/panel';
import { PanelContentSmall } from '../components/panel-content-small';
import { PanelContentLarge } from '../components/panel-content-large';
import { adjustImageUrl } from 'helpers';

import styles from './page.module.scss';
import ideasImage from '../images/ideas.svg';
import expensesImage from '../images/expenses.svg';
import completedImage from '../images/completed.svg';
import titleImage from '../images/title.svg';



export const DonationPageLayout = () => {
	return (
		<div className={styles.container}>
			<div className={styles.wrapper}>
				<div className="flex-size-same flex-container-horizontal">
					<div className={`flex-size-same ${styles.card}`}>
						<Panel>
							<PanelContentLarge title="Будущее инвестиционной базы о ETF" image={adjustImageUrl(titleImage)}>
								<p className={styles.large_content_item}> Некоммерческий проект <a href="https://blog.rusetfs.com/posts/%D1%87%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-rusetfs">RUSETFs</a> развивается благодаря материальной поддержке пользователей. RUSETFS не стоит на месте, совершенствуясь с каждым днем, но развитие требует денежные средства и новые руки. </p>
								<p className={styles.large_content_item + ' ' + styles.help}> Помогите в создании идеальной базы данных для пассивных инвесторов. Ваши пожертвования будут использованы во благо развития проекта. </p>
								<p className={styles.large_content_item}> Рассказываем подробно о проделанной работе в <a href="https://blog.rusetfs.com/?category=%D0%9E%D0%B1%D0%BD%D0%BE%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5">обновлениях</a>. </p>
							</PanelContentLarge>
						</Panel>
					</div>
				</div>
				<div className="flex-size-same flex-container-horizontal flex-container-horizontal-break-1100">
					<div className={`flex-size-same ${styles.card}`}>
						<Panel>
							<PanelContentSmall title="Новые идеи" image={adjustImageUrl(ideasImage)}>
								<ul>
									<li className={styles.small_content_item}>Портфель 2.0 с индексами, сохранением и выбором валют</li>
									<li className={styles.small_content_item}>Анализ составов фондов 2.0</li>
									<li className={styles.small_content_item}>Ликвидность: объемы торгов, оборачиваемость фонда</li>
									<li className={styles.small_content_item}>Тепловая карта изменениям цены фондов</li>
									<li className={styles.small_content_item}>Корреляционная матрица фондов между собой</li>
								</ul>
							</PanelContentSmall>
						</Panel>
					</div>
					<div className={`flex-size-same ${styles.card}`}>
						<Panel>
							<PanelContentSmall title="Ежемесячные траты" image={adjustImageUrl(expensesImage)}>
								<ul>
									<li className={styles.small_content_item}>Аренда сервера - 6 000 рублей</li>
									<li className={styles.small_content_item}>Поддержка домена ~ 120 рублей</li>
									<li className={styles.small_content_item}>Плагины для чата ~ 150 рублей</li>
									<li className={styles.small_content_item}>Договор с биржей о поставке данных - 10 000 рублей</li>
									<li className={styles.small_content_item}>Программистам на печеньки - бесценно</li>
								</ul>
							</PanelContentSmall>
						</Panel>
					</div>
				</div>
				<div className="flex-size-same flex-container-horizontal">
					<div className={`flex-size-same ${styles.card} ${styles.yandex_frame}`}>
						<iframe src="https://yoomoney.ru/quickpay/shop-widget?writer=buyer&targets=&targets-hint=%D0%9F%D0%BE%D0%BC%D0%BE%D0%B3%D1%83%20RUSETFS&default-sum=300&button-text=14&payment-type-choice=on&mobile-payment-type-choice=on&hint=&successURL=&quickpay=shop&account=4100111279198315" width="100%" height="227" frameBorder="0" scrolling="no"></iframe>
					</div>
				</div>
				<div className="flex-size-same flex-container-horizontal">
					<div className={`flex-size-same ${styles.card}`}>
						<Panel>
							<PanelContentSmall title="Уже сделано на собранные пожертвования" image={adjustImageUrl(completedImage)}>
								<ul>
									<li className={styles.small_content_item}>Портфельный калькулятор с произвольным количеством ETF</li>
									<li className={styles.small_content_item}>Сравнение расчетной и биржевой стоимости фондов</li>
									<li className={styles.small_content_item}>Удобный блог для инструкций, новостей и просто интересных статей</li>
									<li className={styles.small_content_item}>Графики котировок фондов в валютах торгов</li>
									<li className={styles.small_content_item}>Интерактивная карта ETF и БПИФ</li>
									<li className={styles.small_content_item}>	Обновленный скринер с удобной фильтрацией и приятными мелочами</li>
								</ul>
							</PanelContentSmall>
						</Panel>
					</div>
				</div>
			</div>
		</div>
	);
}